
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chessparty/lobby",
      function () {
        return require("private-next-pages/chessparty/lobby.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chessparty/lobby"])
      });
    }
  